import { useAuth } from '@/hooks/useAuth';
import NotFound from '@/pages/not-found';

/**
 * Board-member-only route guard — OR-02 (868kmgfck) CA-08.
 *
 * Mirrors the server's `requireRole(['board_member'])` on the
 * board-portal routes: a role that may not open the endpoint must not
 * open the page either, or the link and the API would disagree about
 * who may see the surface.
 *
 * SA-18 EX-06: the default renders `<NotFound />` instead of an
 * access-denied page, so a role that may not use this surface cannot
 * tell that it exists. The property manager and the super admin get
 * their own Official Records screens in OR-04 — until then they see
 * the same 404 as any other unknown route.
 */
export function RequireBoardMember({ children }: { children: React.ReactNode }) {
  const { role, isLoading } = useAuth();
  if (isLoading) {
    return null;
  }
  if (role === 'board_member') {
    return <>{children}</>;
  }
  return <NotFound />;
}
